module.exports = __webpack_public_path__ + "img/r-badge-silver.0fe0001a.png";